export default [
  {
    url: "/",
    name: "ORDER MANAGEMENT",
    slug: "home",
  },
  {
    url: "/account",
    name: "USER MANAGEMENT",
    slug: "home",
  },
  {
    url: "/pages/logout",
    name: "LOGOUT",
    slug: "logout",
  },
  // icon: "HomeIcon",
  // },
  // {
  //   url: "/second",
  //   name: "Second",
  //   slug: "second",

  //   // icon: "HomeIcon",
  // },
  // {
  //   url: "/third",
  //   name: "Thrid",
  //   slug: "third",
  //   // icon: "FileIcon",
  // },
  // {
  //   url: "/fourth",
  //   name: "FORTH",
  //   slug: "fourth",
  //   submenu: [
  //     {
  //       url: "/fourth",
  //       name: "FORTH_1",
  //       slug: "fourth",
  //     },
  //     {
  //       url: "/fourth_2",
  //       name: "FORTH_2",
  //       slug: "fourth",
  //     },
  //   ],

  //   // icon: "FileIcon",
  // },
  // {
  //   url: "/fifth",
  //   name: "Chatbox",
  //   slug: "fifth",
  // },
  // {
  //   url: "/content",
  //   name: "Content",
  //   slug: "content",
  // }
];
